import { bl_fi_nsti_stock_hdr_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class NstiStockContainerModel extends BaseContainerModel {
  bl_fi_nsti_stock_hdr: bl_fi_nsti_stock_hdr_RowClass = new bl_fi_nsti_stock_hdr_RowClass();
}

export class NstiStockQueryCriteria {
  offset: number;
  limit: number;
  orderBy: string;
  order: string;
  keyword: string;
  txn_type: string;
  code: string;
  name: string;
  descr: string;
  status: string;
  param_code: string;
  value_string: string;
}
